/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CommentCreationLocation {
  EDITOR = "EDITOR",
  LIVE = "LIVE",
  RENDERER = "RENDERER",
  WHITEBOARD = "WHITEBOARD",
}

export enum ContentRepresentation {
  ATLAS_DOC_FORMAT = "ATLAS_DOC_FORMAT",
  EDITOR = "EDITOR",
  EDITOR2 = "EDITOR2",
  EXPORT_VIEW = "EXPORT_VIEW",
  PLAIN = "PLAIN",
  RAW = "RAW",
  STORAGE = "STORAGE",
  STYLED_VIEW = "STYLED_VIEW",
  VIEW = "VIEW",
  WIKI = "WIKI",
}

export enum Platform {
  ANDROID = "ANDROID",
  IOS = "IOS",
  WEB = "WEB",
}

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

export interface CommentBody {
  representationFormat: ContentRepresentation;
  value: string;
}

export interface CreateInlineCommentInput {
  commentBody: CommentBody;
  commentSource?: Platform | null;
  containerId: string;
  createdFrom: CommentCreationLocation;
  lastFetchTimeMillis: any;
  matchIndex: number;
  numMatches: number;
  originalSelection: string;
  parentCommentId?: string | null;
  publishedVersion?: number | null;
  step?: Step | null;
}

export interface Mark {
  attrs?: MarkAttribute | null;
  type: string;
}

export interface MarkAttribute {
  annotationType: string;
  id: string;
}

export interface Step {
  from?: any | null;
  mark: Mark;
  to?: any | null;
  pos?: any | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateInlineCommentMutation
// ====================================================

export interface CreateInlineCommentMutation_createInlineComment_body {
  value: string;
}

export interface CreateInlineCommentMutation_createInlineComment_createdAt {
  value: string;
}

export interface CreateInlineCommentMutation_createInlineComment_links {
  webui: string | null;
  editui: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_location_InlineComment_inlineResolveProperties {
  resolved: boolean;
  isDangling: boolean;
  resolvedFriendlyDate: string | null;
  resolvedTime: any | null;
  resolvedUser: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_location_InlineComment {
  type: string;
  inlineMarkerRef: string | null;
  inlineText: string | null;
  inlineResolveProperties: CreateInlineCommentMutation_createInlineComment_location_InlineComment_inlineResolveProperties | null;
}

export interface CreateInlineCommentMutation_createInlineComment_location_FooterComment_commentResolveProperties {
  resolved: boolean;
  resolvedFriendlyDate: string | null;
  resolvedTime: any | null;
  resolvedUser: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_location_FooterComment {
  type: string;
  commentResolveProperties: CreateInlineCommentMutation_createInlineComment_location_FooterComment_commentResolveProperties | null;
}

export type CreateInlineCommentMutation_createInlineComment_location = CreateInlineCommentMutation_createInlineComment_location_InlineComment | CreateInlineCommentMutation_createInlineComment_location_FooterComment;

export interface CreateInlineCommentMutation_createInlineComment_permissions {
  isEditable: boolean;
  isRemovable: boolean;
  isResolvable: boolean;
}

export interface CreateInlineCommentMutation_createInlineComment_version_by {
  displayName: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_version {
  by: CreateInlineCommentMutation_createInlineComment_version_by | null;
  when: string | null;
  number: number | null;
}

export interface CreateInlineCommentMutation_createInlineComment_author_Anonymous_profilePicture {
  path: string;
}

export interface CreateInlineCommentMutation_createInlineComment_author_Anonymous {
  displayName: string | null;
  profilePicture: CreateInlineCommentMutation_createInlineComment_author_Anonymous_profilePicture | null;
  permissionType: SitePermissionType | null;
}

export interface CreateInlineCommentMutation_createInlineComment_author_KnownUser_profilePicture {
  path: string;
}

export interface CreateInlineCommentMutation_createInlineComment_author_KnownUser {
  displayName: string | null;
  profilePicture: CreateInlineCommentMutation_createInlineComment_author_KnownUser_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_author_User_profilePicture {
  path: string;
}

export interface CreateInlineCommentMutation_createInlineComment_author_User {
  displayName: string | null;
  profilePicture: CreateInlineCommentMutation_createInlineComment_author_User_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export type CreateInlineCommentMutation_createInlineComment_author = CreateInlineCommentMutation_createInlineComment_author_Anonymous | CreateInlineCommentMutation_createInlineComment_author_KnownUser | CreateInlineCommentMutation_createInlineComment_author_User;

export interface CreateInlineCommentMutation_createInlineComment_reactionsSummary_reactionsSummaryForEmoji {
  id: string;
  emojiId: string;
  count: number;
  reacted: boolean;
}

export interface CreateInlineCommentMutation_createInlineComment_reactionsSummary {
  ari: string;
  containerAri: string;
  reactionsCount: number;
  reactionsSummaryForEmoji: (CreateInlineCommentMutation_createInlineComment_reactionsSummary_reactionsSummaryForEmoji | null)[];
}

export interface CreateInlineCommentMutation_createInlineComment_replies_body {
  value: string;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_createdAt {
  value: string;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_links {
  webui: string | null;
  editui: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_location_InlineComment_inlineResolveProperties {
  resolved: boolean;
  isDangling: boolean;
  resolvedFriendlyDate: string | null;
  resolvedTime: any | null;
  resolvedUser: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_location_InlineComment {
  type: string;
  inlineMarkerRef: string | null;
  inlineText: string | null;
  inlineResolveProperties: CreateInlineCommentMutation_createInlineComment_replies_location_InlineComment_inlineResolveProperties | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_location_FooterComment_commentResolveProperties {
  resolved: boolean;
  resolvedFriendlyDate: string | null;
  resolvedTime: any | null;
  resolvedUser: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_location_FooterComment {
  type: string;
  commentResolveProperties: CreateInlineCommentMutation_createInlineComment_replies_location_FooterComment_commentResolveProperties | null;
}

export type CreateInlineCommentMutation_createInlineComment_replies_location = CreateInlineCommentMutation_createInlineComment_replies_location_InlineComment | CreateInlineCommentMutation_createInlineComment_replies_location_FooterComment;

export interface CreateInlineCommentMutation_createInlineComment_replies_permissions {
  isEditable: boolean;
  isRemovable: boolean;
  isResolvable: boolean;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_version_by {
  displayName: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_version {
  by: CreateInlineCommentMutation_createInlineComment_replies_version_by | null;
  when: string | null;
  number: number | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_author_Anonymous_profilePicture {
  path: string;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_author_Anonymous {
  displayName: string | null;
  profilePicture: CreateInlineCommentMutation_createInlineComment_replies_author_Anonymous_profilePicture | null;
  permissionType: SitePermissionType | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_author_KnownUser_profilePicture {
  path: string;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_author_KnownUser {
  displayName: string | null;
  profilePicture: CreateInlineCommentMutation_createInlineComment_replies_author_KnownUser_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_author_User_profilePicture {
  path: string;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_author_User {
  displayName: string | null;
  profilePicture: CreateInlineCommentMutation_createInlineComment_replies_author_User_profilePicture | null;
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export type CreateInlineCommentMutation_createInlineComment_replies_author = CreateInlineCommentMutation_createInlineComment_replies_author_Anonymous | CreateInlineCommentMutation_createInlineComment_replies_author_KnownUser | CreateInlineCommentMutation_createInlineComment_replies_author_User;

export interface CreateInlineCommentMutation_createInlineComment_replies_reactionsSummary_reactionsSummaryForEmoji {
  id: string;
  emojiId: string;
  count: number;
  reacted: boolean;
}

export interface CreateInlineCommentMutation_createInlineComment_replies_reactionsSummary {
  ari: string;
  containerAri: string;
  reactionsCount: number;
  reactionsSummaryForEmoji: (CreateInlineCommentMutation_createInlineComment_replies_reactionsSummary_reactionsSummaryForEmoji | null)[];
}

export interface CreateInlineCommentMutation_createInlineComment_replies {
  id: string;
  body: CreateInlineCommentMutation_createInlineComment_replies_body;
  contentStatus: string;
  createdAt: CreateInlineCommentMutation_createInlineComment_replies_createdAt;
  createdAtNonLocalized: string;
  links: CreateInlineCommentMutation_createInlineComment_replies_links;
  location: CreateInlineCommentMutation_createInlineComment_replies_location;
  parentId: string | null;
  permissions: CreateInlineCommentMutation_createInlineComment_replies_permissions;
  version: CreateInlineCommentMutation_createInlineComment_replies_version;
  author: CreateInlineCommentMutation_createInlineComment_replies_author;
  reactionsSummary: CreateInlineCommentMutation_createInlineComment_replies_reactionsSummary | null;
}

export interface CreateInlineCommentMutation_createInlineComment {
  id: string;
  body: CreateInlineCommentMutation_createInlineComment_body;
  contentStatus: string;
  createdAt: CreateInlineCommentMutation_createInlineComment_createdAt;
  createdAtNonLocalized: string;
  links: CreateInlineCommentMutation_createInlineComment_links;
  location: CreateInlineCommentMutation_createInlineComment_location;
  parentId: string | null;
  permissions: CreateInlineCommentMutation_createInlineComment_permissions;
  version: CreateInlineCommentMutation_createInlineComment_version;
  author: CreateInlineCommentMutation_createInlineComment_author;
  reactionsSummary: CreateInlineCommentMutation_createInlineComment_reactionsSummary | null;
  replies: (CreateInlineCommentMutation_createInlineComment_replies | null)[];
}

export interface CreateInlineCommentMutation {
  createInlineComment: CreateInlineCommentMutation_createInlineComment;
}

export interface CreateInlineCommentMutationVariables {
  input: CreateInlineCommentInput;
  pageId: string;
}
